<template>
  <div id="cost-section-parallax">
    <v-parallax
      :height="height"
      class="parallax-header ma-1 mb-3"
      :src="require(`@/assets/images/${banner}`)"
      alt="Photo by Luke Chesser on Unsplash"
    >
      <v-layout align-center justify-center row>
        <h1 class="text-center pt-5">{{title}}</h1>
      </v-layout>

      <v-layout class="cost-info d-none d-sm-flex" justify-center align-center>
        <p class="text--white pa-2 text-center">{{description}}</p>
      </v-layout>
    </v-parallax>
  </div>
</template>

<script>
export default {
  name: "cost-section-parallax",
  props: {
    description: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    banner: {
      type: String,
      default: "https://cdn.vuetifyjs.com/images/parallax/material.jpg",
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    height() {
      return this.step > 3 ? 150 : 100;
    },
  },
};
</script>
